package com.jingfangpai.common.orm.mapping

import kotlinx.serialization.Serializable
import com.jingfangpai.common.orm.mapping.enums.MedicineName
import com.jingfangpai.common.orm.mapping.enums.MedicineType
import com.jingfangpai.common.orm.mapping.enums.MedicineStatus
import com.jingfangpai.common.data.type.DateTime
import com.jingfangpai.common.data.serializer.DateTimeSerializer

@Serializable
open class Medicine(var id: String? = null){
	var name: MedicineName? = null
	var nature: String? = null
	var pinyin: String? = null
	var aliasName: String? = null
	var type: MedicineType? = null
	var description: String? = null
	var status: MedicineStatus? = null
	@Serializable(with = DateTimeSerializer::class)
	var createdOn: DateTime? = null
	var createdBy: String? = null
	@Serializable(with = DateTimeSerializer::class)
	var timestamp: DateTime? = null
	var weight: Int? = null
	var differentiation: String? = null

	override fun equals(other: Any?): Boolean {
		if (this === other) return true
		if (other == null || this::class != other::class) return false
		other as Medicine
		if (id != other.id) return false
		if (name != other.name) return false
		if (nature != other.nature) return false
		if (pinyin != other.pinyin) return false
		if (aliasName != other.aliasName) return false
		if (type != other.type) return false
		if (description != other.description) return false
		if (status != other.status) return false
		if (createdOn != other.createdOn) return false
		if (createdBy != other.createdBy) return false
		if (timestamp != other.timestamp) return false
		if (weight != other.weight) return false
		if (differentiation != other.differentiation) return false
		return true
	}

	override fun hashCode(): Int {
		var result = 0
		result = 31 * result + (id?.hashCode() ?: 0)
		result = 31 * result + (name?.hashCode() ?: 0)
		result = 31 * result + (nature?.hashCode() ?: 0)
		result = 31 * result + (pinyin?.hashCode() ?: 0)
		result = 31 * result + (aliasName?.hashCode() ?: 0)
		result = 31 * result + (type?.hashCode() ?: 0)
		result = 31 * result + (description?.hashCode() ?: 0)
		result = 31 * result + (status?.hashCode() ?: 0)
		result = 31 * result + (createdOn?.hashCode() ?: 0)
		result = 31 * result + (createdBy?.hashCode() ?: 0)
		result = 31 * result + (timestamp?.hashCode() ?: 0)
		result = 31 * result + (weight?.hashCode() ?: 0)
		result = 31 * result + (differentiation?.hashCode() ?: 0)
		return result
	}

}
